function Bundles() {
  return (
    <div>
      <h1>Bundles</h1>
    </div>
  );
}

export default Bundles;
